import React from "react";
import "./PolicyPages.scss";

function DataDeletion() {
  return (
    <div className="policy-page">
      <div className="container">

        <div className="policy-card">

          <h1>Data Deletion Instructions</h1>

          <section>
            <h3>Request Data Deletion</h3>

            <p>
              Users may request deletion of their personal data
              collected through our website, software applications,
              or WhatsApp communication services.
            </p>

            <p>
              To request data deletion, please contact us using the
              email provided below.
            </p>
          </section>

          <section>
            <h3>Contact Information</h3>

            <p>Email: admin@uiplus.in</p>
            <p>Website: https://uiplus.in</p>
            <p>Phone: +91 8855947070</p>
          </section>

          <section>
            <h3>Processing Time</h3>

            <p>
              Verified deletion requests are processed within
              a reasonable timeframe according to applicable
              laws and business requirements.
            </p>
          </section>

        </div>

      </div>
    </div>
  );
}

export default DataDeletion;